import { useEffect, useState } from 'react';
// @mui
import { Box, Container, Stack, Typography, Divider, Button, Collapse, TextField } from '@mui/material';
// components
import { useSettingsContext } from 'src/components/settings';
import Chart, { useChart } from 'src/components/chart';

import { useDispatch, useSelector } from 'src/store';

import { toCurrency } from 'src/utils/to-currency';

// ----------------------------------------------------------------------

const CashbackView = () => {
    const settings = useSettingsContext();
    const { user } = useSelector((state) => state.auth);

    const chartOptions = useChart({
      chart: {
        sparkline: {
          enabled: true,
        },
      },
      legend: {
        show: false,
      },
      fill: {
        type: 'gradient',
        gradient: {
          colorStops: [
            { offset: 0, color: '#323236ff' },
            { offset: 100, color: '#afafb3ff' },
          ],
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '78%',
          },
          track: {
            margin: 0,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: 10,
              color: '#919497c5',
              fontSize: '50',
            },
          },
        },
      },
    });

    return (
        <Container maxWidth={settings.themeStretch ? false : 'xl'} sx={{ pb: 2 }}>
            <Stack
                sx={{
                    p: 1,
                    width: 1,
                    mt: { xs: 1, md: 5 }
                }}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="h5" my={1}>Cashback</Typography>
            </Stack>

            <Divider sx={{ mb: 1 }} />

            <Typography variant="h6" my={0.5} textTransform="uppercase" fontWeight="bold" textAlign="center">Current Cashback Level</Typography>

            <Stack alignItems="center" justifyContent="center">
                <Chart type="radialBar" series={[10]} options={chartOptions} width={300} height={300} />
            </Stack>

            <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" gap={1} mt={2}>
                <TextField name="currentCashback" label="Current Cashback" value={0} disabled />

                <TextField
                    name="deposit"
                    label="Deposit"
                    value={0}
                    disabled
                />

                <TextField
                    name="climeCashback"
                    label="Clime Cashback"
                    value={0}
                    disabled
                />
            </Stack>
        </Container >
    );
}

export default CashbackView;